export default __webpack_public_path__ + "static/media/banner1.6d628bd2.svg";